<gl-base-modal (closeModal)="close()">
  <h2 class="title">{{ 'change_unit_header' | translate }}</h2>
  <p class="info">{{ 'change_unit_message' | translate }}</p>
  <div class="buttons center">
    <button normal-outline-button (click)="changeUnits()">
      {{ 'yes' | translate }}
    </button>
    <button outline-button (click)="close()">{{ 'no' | translate }}</button>
  </div>
</gl-base-modal>
